





















































































































































































































































































































































































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import CompaniesSwitcher from "@/components/CompaniesSwitcher.vue";
import CategoryPathsViewer from "@/components/CategoryPathsViewer.vue";
import dayjs from "dayjs";
import errorsUtil from "./../utils/errorMappings";
import _ from "lodash";

interface Profile {
  accountId: string;
  companyId: string;
  categories: string[];
  createdBy: string;
  createdAt: string;
  deletedAt: string;
  isDefault: boolean;
  profileId: string;
  profileName: string;
  updatedBy: string;
  updatedAt: string;
}

@Component({
  components: {
    CompaniesSwitcher,
    CategoryPathsViewer,
  },
})
export default class BulkProfileList extends Vue {
  @Provide("$api") $api: any;
  @Provide("$_") $_: any;

  @Prop() private companyId!: string;
  @Prop() private accountId!: string;
  @Prop({ default: () => 1 }) private page!: number;

  private from = "";

  private pageNumber = this.page;
  private paginationRowsPerPage = 20;
  private paginationTotalRecords = 0;

  private profilesData: Profile[] = [];
  private profileToDelete = {};
  private profileToDefault = {};
  private defaultProfile = {};
  private loading = true;
  private currentSortField = "createdAt";
  private sortTypeASC = false;
  private profileNameField = "profileName";
  private errorMessageTop = "";

  mounted() {
    this.getProfiles();
  }

  private displayError(error) {
    const errorCode = error.response.data.code;
    if (_.has(errorsUtil.errorMessages, errorCode)) {
      this.$store.commit("recordError", "");
      this.errorMessageTop = errorsUtil.errorMessages[errorCode];
    }
  }

  @Watch("companyId")
  @Watch("currentSortField")
  @Watch("sortTypeASC")
  async getProfiles() {
    this.$store.commit("startLoading");
    this.loading = true;
    try {
      const response = await this.$api.get(
        `item-classification-api/v1/profiles/${this.companyId}/default`
      );
      this.defaultProfile = response.data;
    } catch (error) {
      if (error.response.status === 404) {
        this.$store.commit("recordError", "");
      } else {
        this.$store.commit("stopLoading");
        this.displayError(error);
        return;
      }
    }
    this.$store.commit("startLoading");
    const skip = this.paginationStartIndex();
    const top = this.paginationRowsPerPage;
    const orderBy =
      this.currentSortField + (this.sortTypeASC ? " ASC" : " DESC");
    this.$api
      .get(
        `item-classification-api/v1/profiles/${this.companyId}?skip=${skip}&top=${top}&orderBy=${orderBy}`
      )
      .then((response) => {
        this.paginationTotalRecords = response.data.recordsetCount;
        const profiles: Profile[] = response.data.value;
        this.profilesData = profiles.filter((p) => !p.isDefault) || [];
        this.$store.commit("stopLoading");
        this.loading = false;
      })
      .catch((error) => {
        this.$store.commit("stopLoading");
        this.loading = false;
        this.displayError(error);
      });
  }

  deleteProfile() {
    this.closeDeleteDialog();
    this.$store.commit("startLoading");
    this.$api
      .delete(
        `item-classification-api/v1/profiles/${this.companyId}/${
          (this.profileToDelete as Profile).profileId
        }`
      )
      .then((response) => {
        this.$store.commit("stopLoading");
        this.getProfiles();
        this.$store.commit(
          "recordToast",
          `"${(this.profileToDelete as Profile).profileName}" was deleted.`
        );
      })
      .catch((error) => {
        this.$store.commit("stopLoading");
        this.displayError(error);
      });
  }

  setDefaultProfile() {
    (this.$refs["set-default-profile"] as any).close();
    const profile = this.profileToDefault as Profile;
    this.$store.commit("startLoading");
    this.$api
      .put(
        `item-classification-api/v1/profiles/${this.companyId}/default`,
        null,
        { params: { profileId: profile.profileId } }
      )
      .then((response) => {
        this.$store.commit("stopLoading");
        this.getProfiles();
        this.$store.commit(
          "recordToast",
          `"${
            (this.profileToDefault as Profile).profileName
          }" successfully set as the default classification profile.`
        );
      })
      .catch((error) => {
        this.$store.commit("stopLoading");
        this.displayError(error);
      });
  }

  companySwitched(event) {
    const params = Object.assign({}, this.$route.params, {
      companyId: event.companyId,
    });

    this.$router.push({ name: "profile_list", params: params });
  }

  async onPageChange(e: any) {
    const hasPageChanged =
      e.detail.currentPage !== 0 && e.detail.currentPage !== this.pageNumber;
    const hasRowsPerPageChanged =
      e.detail.rowsPerPage !== this.paginationRowsPerPage;
    if (hasPageChanged) {
      this.pageNumber = e.detail.currentPage;
      const query = Object.assign({}, this.$route.query);
      query.page = e.detail.currentPage;
      this.$router.push({ query });
    }
    this.paginationRowsPerPage = e.detail.rowsPerPage;
    if (hasPageChanged || hasRowsPerPageChanged) this.getProfiles();
  }

  private paginationStartIndex() {
    return (this.pageNumber - 1) * this.paginationRowsPerPage;
  }

  private openDeleteDialog(e, profile) {
    this.profileToDelete = profile;
    (this.$refs["profile-delete"] as any).showModal();
  }

  private openDefaultDialog(e, profile) {
    this.profileToDefault = profile;
    (this.$refs["set-default-profile"] as any).showModal();
  }

  private closeDeleteDialog() {
    (this.$refs["profile-delete"] as any).close();
  }

  private closeDefaultDialog() {
    (this.$refs["set-default-profile"] as any).close();
    this.getProfiles();
  }

  private formatDate(date) {
    return dayjs(date).format("YYYY/MM/DD");
  }

  private onSortChange(field) {
    if (this.currentSortField === field) this.sortTypeASC = !this.sortTypeASC;
    else {
      this.currentSortField = field;
      this.sortTypeASC = false;
    }
  }

  sortIconType(field) {
    if (this.currentSortField === field)
      return this.sortTypeASC ? "arrow-up" : "arrow-down";
    return "arrow-down";
  }
}
